import defaultConf from './config.json';

let _config = defaultConf || {};

export function set(name = '', value = null) {
    if (name && typeof name === 'object') {
        _config = {..._config, ...name};
    } else if (name && typeof name === 'string') {
        _config[name] = value;
    }

    return _config;
}

export function get(name = '') {
    if (typeof _config[name] !== 'undefined') {
        return _config[name];
    } else {
        return null;
    }
}

export function api(name = '') {
    if (
        name === 'API_TOOLS' ||
        name === 'API_GET_RECEIPT_NEW' ||
        name === 'API_PHONE_TOP_UP' ||
        name === 'API_PAYMENTS' ||
        name === 'API_CREDITS_LOANS' ||
        name === 'API_P2P_TRANSFER'
    ) {
        return (_config.API_BASE_TOOLS || '/') + _config[name];
    }
    if (name === 'API_STATEMENTS_TRANSACTION') {
        return (_config.API_BASE_V7 || '/') + _config[name];
    }
    if (
        name === 'API_CARDS' ||
        name === 'API_CARD_V2_DEBT' ||
        name === 'API_COURSES_NEW' ||
        name === 'API_LOGIN'
    ) {
        return (_config.API_BASE_V2 || '/') + _config[name];
    }
    if (name === 'CARD_LIMITS_URL' || name === 'CHANGE_CARD_SETTING') {
        return (_config.API_BASE_NEW || '/') + _config[name];
    }
    if (
        name === 'API_GET_RECEIPT' ||
        name === 'API_SEND_TO_EMAIL' ||
        name === 'API_CHECK_TEACH_SESSION'
    ) {
        return (_config.API_BASE || '/') + _config[name] + `?xref=${get('XREF')}`;
    }
    if (_config[name]) {
        return (_config.API_BASE || '/') + _config[name];
    } else {
        return '/';
    }
}

export function login(name = '') {
    if (_config[name]) {
        return (_config.API_LOGIN || '/') + _config[name];
    } else {
        return '/';
    }
}
